/*
 * PAWS & PEARLS — THE MUSE — HIPPO WATER-TO-FLIGHT V1.2 · 27 October 2026
 * MAGICAL MUSE WORLD unpublished Shopify duplicate theme ONLY.
 *
 * PATCH PURPOSE: preserve V1.1 lower-right swim and sizes, plus restore depth
 * in BOTH airborne direction changes via the archived approved FRONT PNG.
 *
 * - keeps the approved 16 hippo frames already uploaded in Shopify;
 * - moves the WATER phase lower-right into the bay;
 * - makes the hippo noticeably smaller while in the water;
 * - preserves the larger airborne scale near Lilla;
 * - keeps the same overall story beats and independence from other layers.
 *
 * Timing is measured after The Muse's actual balloon click:
 *   20–34.5s peaceful swimming in the lower-right bay;
 *   34.5–40.6s emergence, subtle sparkles, sudden rose-gold wing reveal;
 *   40.6–44.2s rise and flight toward Lilla;
 *   44.2–48.9s brief meeting near Lilla's hover;
 *   48.9–55.4s separate departure: hippo UP-RIGHT, Lilla UP-LEFT.
 *   Hide before Muse starts her descent. No ghost/alpha effects.
 */
(function () {
  'use strict';
  var VERSION='1.2-front-facing-double-turn', ROOT='pp-muse-secret-sky', STAGE='pp-muse-balloon-stage';
  var CFG='pp-muse-hippo-frame-urls', LAYER='pp-muse-hippo-water-flight-v1', STYLE=LAYER+'-style';
  // Read the Shopify asset URL from the ONE existing script reference as it executes.
  // No edits to the established 16-frame holder are necessary.
  var FRONT_URL=(document.currentScript&&document.currentScript.getAttribute('data-hippo-front-url'))||'';
  var instance=null, run=null, raf=0;
  var CLOCK={swimStart:20,emerge:34.5,magic:37,wing:39,lift:40.6,approach:42.0,
             meet:44.2,separate:48.9,end:55.4};
  /* Madam's correction: hippo starts lower-right in the bay, then rises to current meeting zone. */
  var position={waterX:84.8,waterY:55.2,meetX:84.5,meetY:39.0};
  function clamp(a,x,b){return Math.min(b,Math.max(a,x));}
  function ease(x){x=clamp(0,x,1);return x*x*(3-2*x);}
  function mix(a,b,t){return a+(b-a)*t;}
  function blend(a,b,time,from,to){return mix(a,b,ease((time-from)/(to-from)));}
  function log(s){if(window.console&&console.info)console.info('[P&P Hippo V1.2] '+s);}
  function reduced(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;}
  function desktop(){return (window.innerWidth||1024)>=768;}
  function assetUrls(){
    var holder=document.getElementById(CFG);
    if(!holder)return null;
    var urls={};
    for(var i=1;i<=16;i++){
      var key='f'+String(i).padStart(2,'0');
      var url=holder.getAttribute('data-'+key);
      if(!url||!(/^(https?:\/\/|\/)/.test(url)))return null;
      urls[key]=url;
    }
    return urls;
  }
  function ensureStyle(){
    if(document.getElementById(STYLE))return;
    var st=document.createElement('style'); st.id=STYLE;
    st.textContent=[
      'html.pp-muse-secret-sky-page #'+ROOT+' #'+LAYER+'{position:absolute!important;inset:0!important;z-index:4!important;pointer-events:none!important;overflow:hidden!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #'+LAYER+' .pp-hippo-actor{position:absolute!important;left:0;top:0;display:none;pointer-events:none!important;user-select:none!important;transform-origin:center center;will-change:transform,left,top,width;}',
      'html.pp-muse-secret-sky-page #'+LAYER+' .pp-hippo-actor img{display:block!important;width:100%!important;height:auto!important;max-width:none!important;opacity:1!important;object-fit:contain!important;pointer-events:none!important;-webkit-user-drag:none;filter:none!important;}',
      '@media(max-width:767px){html.pp-muse-secret-sky-page #'+LAYER+'{display:none!important;}}',
      '@media(prefers-reduced-motion:reduce){html.pp-muse-secret-sky-page #'+LAYER+'{display:none!important;}}'
    ].join('');document.head.appendChild(st);
  }
  function setup(){
    if(!document.documentElement.classList.contains('pp-muse-secret-sky-page'))return null;
    var sky=document.getElementById(ROOT),wrapper=document.querySelector('.page-wrapper');
    if(!sky||!wrapper||!wrapper.contains(sky))return null;
    if(instance&&instance.sky===sky&&instance.layer.isConnected)return instance;
    var urls=assetUrls();if(!urls){log('16 frame URLs missing; sky left unchanged.');return null;}
    ensureStyle();
    if(instance&&instance.layer)instance.layer.remove();
    var layer=document.createElement('div'); layer.id=LAYER;layer.setAttribute('aria-hidden','true');
    var actor=document.createElement('div');actor.className='pp-hippo-actor';
    var img=document.createElement('img');img.alt='';img.decoding='async';img.loading='eager';img.draggable=false;
    actor.appendChild(img);layer.appendChild(actor);sky.appendChild(layer);
    var frames={};
    for(var k in urls){var im=new Image();im.decoding='async';im.src=urls[k];frames[k]=im;}
    // The additional, approved head-on frame is preloaded separately.
    // A missing front image never suppresses the existing sixteen-frame narrative.
    if(FRONT_URL&&/^(https?:\/\/|\/)/.test(FRONT_URL)){
      var front=new Image();front.decoding='async';front.src=FRONT_URL;frames.front=front;
    }else{log('Front-frame URL missing: original side images remain available.');}
    instance={sky:sky,layer:layer,actor:actor,img:img,frames:frames,urls:urls};
    log('Approved hippo V1.2 with both front-facing turns ready; waiting for Muse balloon click.');
    return instance;
  }
  function cancel(){if(raf)cancelAnimationFrame(raf);raf=0;run=null;
    if(instance){instance.actor.style.display='none';}}
  function begin(){if(reduced()||!desktop())return;
    var env=setup();if(!env)return;
    cancel();run={env:env,start:performance.now(),lastKey:'',phase:'waiting',elapsed:0};
    raf=requestAnimationFrame(tick);log('Swimming will begin 20 seconds after Muse click.');
  }
  function showFrame(key){
    if(!run||run.lastKey===key)return;
    var im=run.env.frames[key];
    if(im&&im.complete&&im.naturalWidth>0){run.env.img.src=im.src;run.lastKey=key;}
  }
  function frameForSwim(t){
    var seq=['f01','f02','f01','f03','f04','f02','f05','f01','f04'];
    return seq[Math.min(seq.length-1,Math.floor((t-CLOCK.swimStart)/1.65))];
  }
  // A 2D sprite cannot be rotated through an edge-on view without vanishing.
  // Hold a real FRONT image between two intact side views instead. The silhouette
  // and torso therefore remain legible throughout the two direction changes.
  // The scaling .744 is matched to the approved 27 Oct two-turn study: original
  // airborne PNGs have significant transparent margins, while the front view doesn't.
  function turnView(t,from,to,fromFacing,toFacing){
    var u=ease((t-from)/(to-from));
    if(u>=.30&&u<.70)return {front:true,scale:.744,facing:1};
    if(u<.30)return {front:false,scale:1-.055*(u/.30),facing:fromFacing};
    return {front:false,scale:.945+.055*((u-.70)/.30),facing:toFacing};
  }
  function waterSize(){return clamp(110,(window.innerWidth||1440)*0.092,150);}   /* smaller in the bay */
  function flightSize(){return clamp(143,(window.innerWidth||1440)*0.133,192);}  /* preserve Madam-approved airborne base size */
  function tick(now){
    raf=0;var r=run;if(!r||!r.env.layer.isConnected)return;
    var t=(now-r.start)/1000;r.elapsed=t;
    if(t>=CLOCK.end){cancel();log('Hippo departed safely up-right.');return;}
    if(t<CLOCK.swimStart){r.env.actor.style.display='none';raf=requestAnimationFrame(tick);return;}
    if(!desktop()||reduced()){r.env.actor.style.display='none';raf=requestAnimationFrame(tick);return;}
    var x=position.waterX,y=position.waterY,key='f01',size=waterSize();
    var facing=1,roll=0,bob=0,phase='swimming';
    if(t<CLOCK.emerge){
      var q=t-CLOCK.swimStart;
      x=position.waterX+1.85*Math.sin(q*Math.PI*2/7.7);
      y=position.waterY+0.35*Math.sin(q*Math.PI*2/3.8);
      key=frameForSwim(t);bob=1.5*Math.sin(q*Math.PI*2/2.6);phase='swimming';
    }else if(t<CLOCK.magic){
      x=position.waterX+0.4;
      y=blend(position.waterY,51.6,t,CLOCK.emerge,CLOCK.magic);
      key=t<35.4?'f05':(t<36.2?'f06':'f07');
      size=blend(waterSize(),waterSize()*1.03,t,CLOCK.emerge,CLOCK.magic);
      phase='rising';
    }else if(t<CLOCK.wing){
      x=position.waterX+0.4;y=51.6;
      key=t<37.9?'f08':'f09';
      size=blend(waterSize()*1.03,waterSize()*1.08,t,CLOCK.magic,CLOCK.wing);
      phase='first-magic';
    }else if(t<CLOCK.lift){
      x=position.waterX+0.4;y=51.6;
      key=t<39.7?'f10':'f11';
      size=blend(waterSize()*1.08,waterSize()*1.14,t,CLOCK.wing,CLOCK.lift);
      phase='wings-emerge';
    }else if(t<CLOCK.approach){
      x=blend(position.waterX+0.4,84.2,t,CLOCK.lift,CLOCK.approach);
      y=blend(51.6,44.2,t,CLOCK.lift,CLOCK.approach);
      key=t<41.2?'f12':'f13';
      size=blend(waterSize()*1.14,flightSize()*1.02,t,CLOCK.lift,CLOCK.approach);
      phase='lift-off';
    }else if(t<CLOCK.meet){
      x=blend(84.2,position.meetX,t,CLOCK.approach,CLOCK.meet);
      y=blend(44.2,position.meetY,t,CLOCK.approach,CLOCK.meet);
      key=t<43.0?'f14':'f15';
      size=blend(flightSize()*1.02,flightSize()*1.08,t,CLOCK.approach,CLOCK.meet);
      facing=t<42.8?1:-1; // corrected continuous view applied below
      phase='toward-lilla';
    }else if(t<CLOCK.separate){
      x=position.meetX;
      y=position.meetY+0.17*Math.sin((t-CLOCK.meet)*Math.PI*2/2.4);
      key='f15';size=flightSize()*1.08;facing=-1;
      bob=3.2*Math.sin((t-CLOCK.meet)*Math.PI*2/2.8);
      phase='rendezvous';
    }else{
      var u=ease((t-CLOCK.separate)/(CLOCK.end-CLOCK.separate));
      x=mix(position.meetX,105,u);
      y=mix(position.meetY,17,u)-Math.sin(Math.PI*u)*4;
      size=mix(flightSize()*1.08,flightSize()*0.53,u);
      key=t<CLOCK.separate+2?'f16':(t<CLOCK.separate+4?'f14':'f13');
      facing=t<CLOCK.separate+1.15?-1:1; // corrected continuous view applied below
      roll=-4.5*u;phase='departing-right';
    }
    // Two true front-on views, at the middle of BOTH turns.
    // Keep full side silhouettes on either side of the front keyframe;
    // never animate scaleX through zero (the former cardboard effect).
    var turn=null;
    if(t>=42.8&&t<44.2)turn=turnView(t,42.8,44.2,1,-1);
    if(t>=CLOCK.separate&&t<CLOCK.separate+1.15)
      turn=turnView(t,CLOCK.separate,CLOCK.separate+1.15,-1,1);
    if(turn){
      var front=r.env.frames.front;
      var frontReady=!!(front&&front.complete&&front.naturalWidth>0);
      if(turn.front&&frontReady){
        key='front';facing=1;size*=turn.scale;r.view='front';
      }else if(turn.front){
        // A missing or late image must not make the hippo vanish.
        facing=(t<44.2 ? (t<43.5?1:-1) : (t<49.475?-1:1));
        size*=.945;r.view='side-front-fallback';
      }else{
        facing=turn.facing;size*=turn.scale;r.view=facing<0?'left-side':'right-side';
      }
    }else{r.view=facing<0?'left-side':'right-side';}
    showFrame(key);
    r.env.actor.style.left=x.toFixed(3)+'%';
    r.env.actor.style.top=y.toFixed(3)+'%';
    r.env.actor.style.width=size.toFixed(1)+'px';
    r.env.actor.style.transform='translate(-50%,-50%) translate3d(0,'+bob.toFixed(2)+'px,0) scaleX('+facing.toFixed(3)+') rotate('+roll.toFixed(2)+'deg)';
    r.env.actor.style.display=r.lastKey?'block':'none';
    r.phase=phase;
    raf=requestAnimationFrame(tick);
  }
  function onClick(event){
    var e=event.target;
    var clicked=e&&e.closest&&e.closest('#'+STAGE+' .pp-balloon, .pp-muse-flight-overlay.pp-balloon');
    if(clicked)begin();
  }
  function initialize(){setup();}
  window.ppMuseHippoV1={
    version:VERSION, getStatus:function(){return {
      present:!!(instance&&instance.layer&&instance.layer.isConnected),
      running:!!run,phase:run?run.phase:'idle',
      secondsAfterMuseClick:run?Math.round(run.elapsed*10)/10:null,
      meetingWindowSeconds:[CLOCK.meet,CLOCK.separate],
      frontFrameConfigured:!!FRONT_URL,
      frontFrameLoaded:!!(instance&&instance.frames.front&&instance.frames.front.complete&&instance.frames.front.naturalWidth>0),
      currentView:run?run.view:'none',
      frontTurnWindowsSeconds:[[42.8,44.2],[48.9,50.05]],
      changesExistingFlight:false,opacityOfVisibleHippo:1,
      waterBayPosition:position,waterSizeExampleAt1440:Math.round(1440*0.092),flightSizeExampleAt1440:Math.round(1440*0.133)
    };}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('click',onClick,false);
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',function(e){if(instance&&e.target&&e.target.contains(instance.sky)){cancel();instance.layer.remove();instance=null;}});
  window.addEventListener('pageshow',initialize);
})();
